import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

const PublicRoute = ({
    isLogged,
    component: Component,
    ...rest
}) => {

    return <Route { ...rest } component={(props) => (!isLogged ? <Component {...props} /> : <Redirect to='/dashboard' />)} />
}

PublicRoute.protoTypes = {
    isLogged: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}

export default PublicRoute;